import React from "react";
import { APPLICATION_VERSION } from "../../../constants";

export default class VersionComponent extends React.Component {
  public render = (): JSX.Element => {
    return <div>{APPLICATION_VERSION}</div>;
  };
}
